import { Alert, Typography } from '@mui/material';
import { isEmpty, join } from 'lodash';
import React from 'react';

import type { PreviousJobComparisonStatus } from './previousJobComparisonStatus';

interface PreviousJobComparisonAlertProps {
  status?: PreviousJobComparisonStatus;
  matchMessage: string;
  modifiedMessage: string;
}

const PreviousJobComparisonAlert: React.FC<React.PropsWithChildren<PreviousJobComparisonAlertProps>> = ({
  status,
  matchMessage,
  modifiedMessage,
}) => {
  if (!status?.hasPreviousJobSettings) {
    return null;
  }

  return (
    <Alert severity={status.isModified ? 'warning' : 'info'} sx={{ maxWidth: 800 }}>
      <Typography>{status.isModified ? modifiedMessage : matchMessage}</Typography>
      {status.isModified && !isEmpty(status.discrepancyLabels) && (
        <Typography variant="body2">Changed: {join(status.discrepancyLabels, ', ')}.</Typography>
      )}
    </Alert>
  );
};

export default PreviousJobComparisonAlert;
